// Class: motion.easing.Sine

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $import = require("./../../import_stub").default;
function motion_easing__$Sine_SineEaseIn() {return require("./../../motion/easing/_Sine/SineEaseIn");}
function motion_easing__$Sine_SineEaseInOut() {return require("./../../motion/easing/_Sine/SineEaseInOut");}
function motion_easing__$Sine_SineEaseOut() {return require("./../../motion/easing/_Sine/SineEaseOut");}

// Constructor

var Sine = function(){}

// Meta

Sine.__name__ = ["motion","easing","Sine"];
Sine.__isInterface__ = false;
Sine.prototype = {
	
};
Sine.prototype.__class__ = Sine.prototype.constructor = $hxClasses["motion.easing.Sine"] = Sine;

// Init



// Statics


Sine.easeIn = new (motion_easing__$Sine_SineEaseIn().default)()
Sine.easeInOut = new (motion_easing__$Sine_SineEaseInOut().default)()
Sine.easeOut = new (motion_easing__$Sine_SineEaseOut().default)()

// Export

exports.default = Sine;